import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Globe, Radar, Search, Plus, Building2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { LeadMarketFields } from './LeadMarketFields';
import './lead-discovery.css';

export const LeadSearchBar = ({ theme, settings, workspaceId, api, onStart, onAddWebsite }) => {
  const [city, setCity] = useState('');
  const [industries, setIndustries] = useState([]);
  const [website, setWebsite] = useState('');
  const [busy, setBusy] = useState('');
  const run = async (kind, fn) => {
    if (busy) return;
    setBusy(kind);
    try { await fn(); } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Something went wrong. Please try again.');
    } finally { setBusy(''); }
  };
  const find = () => run('find', () => onStart({ city: city.trim(), industries, target_results: settings?.has_own_key ? 1000 : 60 }));
  const add = () => website.trim() && run('add', async () => { await onAddWebsite(website.trim()); setWebsite(''); });
  return <div className={`lead-discovery ${theme.isDarkMode ? 'lead-discovery-dark' : ''}`}>
    <section className="lead-discovery-section" data-testid="lead-search-bar">
      <div className="lead-section-label"><Radar size={13}/><span>Scan a Market</span></div>
      <LeadMarketFields {...{ api, workspaceId, city, setCity, industries, setIndustries }} options={settings?.industries || []}/>
      <div className="lead-discovery-footer">
        <div className="lead-discovery-quota"><span className="lead-quota-pill" data-testid="lead-target-static"><Building2 size={12}/>Up to {settings?.has_own_key ? '1,000' : '60'} / industry · Free</span>
          <span data-testid="lead-search-cap-info">{settings?.searches_used_this_month ?? 0}/{settings?.monthly_search_cap ?? 1000} free searches · <Link data-testid="lead-connect-google-key" to={`/workspace/${workspaceId}/integrations`}>{settings?.has_own_key ? 'Manage integrations' : 'Connect your Google key'}</Link></span>
        </div>
        <button className="lead-discovery-cta" data-testid="lead-search-start-btn" disabled={!city.trim() || !industries.length || !!busy} onClick={find}>
          {busy === 'find' ? <Loader2 size={15} className="animate-spin"/> : <Search size={15}/>}Find Businesses</button>
      </div>
    </section>
    <section className="lead-discovery-section" data-testid="quick-url-card">
      <div className="lead-section-label"><Globe size={13}/><span>Have a Specific Business?</span></div>
      <div className="lead-url-row"><label className="lead-pill-input"><Globe size={14}/><input aria-label="Business website" data-testid="quick-url-input" value={website} onChange={e => setWebsite(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') add(); }} placeholder="Paste their website — e.g. joesplumbing.com"/></label>
        <button className="lead-discovery-cta" data-testid="quick-add-btn" disabled={!website.trim() || !!busy} onClick={add}>
          {busy === 'add' ? <Loader2 size={15} className="animate-spin"/> : <Plus size={15}/>}Add to Leads</button></div>
      <p className="lead-section-caption">Added free. Run Deep Analysis &amp; Proposal from your Leads whenever you're ready.</p>
    </section>
  </div>;
};
export default LeadSearchBar;
